module.exports = __webpack_public_path__ + "img/20210530.71f78cbb.gif";